import { SHOW_PARKING_PROGRESS_POPUP } from "./showParkingInProgressPopUpReducer"

export const displayParkingInProgressPopup = (value) => ({
    type: SHOW_PARKING_PROGRESS_POPUP,
    payload: value
})